import { useTypedQuery } from "hooks";
import { useIncompleteTyresFilters } from "modules/IncompleteTyresDashboard/hooks/useIncompleteTyresFilters";
import { IncompleteTyresQueryKeys } from "modules/IncompleteTyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useIncompleteTyresQuery = () => {
  const filters = useIncompleteTyresFilters();

  const { data, refetch, isFetching } = useTypedQuery({
    queryKey: IncompleteTyresQueryKeys.incompleteTyres,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, filters, baseUrl)).data,
    refetchOnDependencies: [filters]
  });

  return { tyres: data?.tyres ?? [], nbItems: data?.nb_items ?? 0, nbPages: data?.nb_pages ?? 0, refetch, isFetching };
};
